/**
 * Open a URL in a centered popup window at 50%×50% of the screen.
 *
 * Scope: used by the Unified Federation Hub footer surfaces only
 * (hub board links, community chat outbound, Old Minds portals,
 * affiliate slots, integrated Federation Map pillars).  Main site
 * navigation and non-footer links do NOT use this helper.
 *
 * The click handler prevents default anchor navigation so we can
 * dictate the exact popup geometry.  Browsers only honor popup
 * features when opened in direct response to a user gesture, which
 * this handler satisfies.
 */
export function openCenteredPopup(url) {
  if (!url) return;
  const w = Math.round(window.screen.width * 0.5);
  const h = Math.round(window.screen.height * 0.5);
  const left = Math.round(window.screen.width * 0.25);
  const top = Math.round(window.screen.height * 0.25);
  const features = `width=${w},height=${h},left=${left},top=${top},toolbar=no,menubar=no,scrollbars=yes,resizable=yes`;
  window.open(url, '_blank', features);
}

/**
 * Convenience click handler factory — attach to anchor onClick to
 * intercept the default navigation and route through the popup.
 *
 *   <a href={url} onClick={handlePopupClick(url)}>...</a>
 */
export function handlePopupClick(url) {
  return (e) => {
    e.preventDefault();
    openCenteredPopup(url);
  };
}
